function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Track = /*#__PURE__*/function () {
  function Track() {
    _classCallCheck(this, Track);

    /** @type {number} */
    this.id = -1;
    /** @type {number} */

    this.sequenceNumber = 0;
    /** @type {*} */

    this.samples = [];
    /** @type {*} */

    this.droppedSamples = [];
    /** @type {number} */

    this.length = 0;
  }

  _createClass(Track, [{
    key: "reset",
    value: function reset() {
      this.sequenceNumber = 0;
      this.samples = [];
      this.length = 0;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.reset();
      this.id = -1;
    }
  }]);

  return Track;
}();

export { Track as default };
export var AudioTrack = /*#__PURE__*/function (_Track) {
  _inherits(AudioTrack, _Track);

  var _super = _createSuper(AudioTrack);

  function AudioTrack() {
    var _this;

    _classCallCheck(this, AudioTrack);

    _this = _super.call(this);
    /** @type {string} */

    _this.TAG = 'AudioTrack';
    /** @type {string} */

    _this.type = 'audio';
    return _this;
  }

  return AudioTrack;
}(Track);
export var VideoTrack = /*#__PURE__*/function (_Track2) {
  _inherits(VideoTrack, _Track2);

  var _super2 = _createSuper(VideoTrack);

  function VideoTrack() {
    var _this2;

    _classCallCheck(this, VideoTrack);

    _this2 = _super2.call(this);
    /** @type {string} */

    _this2.TAG = 'VideoTrack';
    /** @type {string} */

    _this2.type = 'video';
    /** @type {number} */

    _this2.dropped = 0;
    /** @type {number} */

    _this2.sequenceNumber = 0;
    return _this2;
  }

  _createClass(VideoTrack, [{
    key: "reset",
    value: function reset() {
      this.sequenceNumber = 0;
      this.samples = [];
      this.length = 0;
      this.dropped = 0;
    }
  }]);

  return VideoTrack;
}(Track);
export var Tracks = /*#__PURE__*/function () {
  function Tracks() {
    _classCallCheck(this, Tracks);

    this.audioTrack = null;
    this.videoTrack = null;
  }

  _createClass(Tracks, [{
    key: "destroy",
    value: function destroy() {
      this.audioTrack = null;
      this.videoTrack = null;
    }
  }]);

  return Tracks;
}();